import { CONFIG, goToCheckout, whatsappUrl } from "../../config";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { useI18n } from "../../i18n";

export default function StickyCTA() {
  const { t, currency, fmtCcy } = useI18n();
  return (
    <div data-testid="sticky-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-[#23232a] bg-[#0a0a0b]/95 backdrop-blur-xl px-3 py-2.5 flex items-center gap-2 safe-bottom">
      
      <div className="flex-1 min-w-0 ml-1">
        <div className="flex items-baseline gap-2">
          <span className="font-display font-black text-base text-[color:var(--gold)]">{fmtCcy(currency.price)}</span>
          <span className="text-[10px] text-[color:var(--ink-mute)] line-through">{fmtCcy(currency.mrp)}</span>
        </div>
        <div className="font-mono text-[9px] uppercase tracking-widest text-[color:var(--ink-mute)] truncate">
          {CONFIG.COPIES_LEFT} · {t("hero_badge_copies", { n: CONFIG.COPIES_LEFT })}
        </div>
      </div>
      <button onClick={() => goToCheckout(currency.code, currency.price)} data-testid="sticky-buy"
        className="btn-gold h-11 px-4 rounded-full inline-flex items-center gap-1.5 text-[13px] font-display whitespace-nowrap">
        {t("nav_get_access")} <ArrowUpRight className="w-4 h-4" />
      </button>
    </div>
  );
}
